module.exports = __webpack_public_path__ + "img/PhotoExhibit-Iceland.7555d0c1.jpg";